import React from 'react';

export const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = React.useState(0);

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
}

export const getWindowHeight = () => (typeof window !== 'undefined' ? window.innerHeight : 9999);
